import * as React from 'react';
import { Dropdown } from 'react-bootstrap';
import clsx from 'clsx';
import styled from 'styled-components';
import { SvgImage } from '../SvgImage';
import { IRowOptionsProps, ICustomToggleProps } from './RowOptions.types';
import { getAssetPath } from '../../util/images';

const RowOptionsToggle = styled.button`
  border: unset;
  background: unset;
  &:focus {
    outline: unset;
  }
`;

const RowOptionsDropdown = styled(Dropdown)`
  table .dropdown button {
    margin: unset;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: $color-d1;
  }

  .dropdown-menu {
    background-color: ${({ theme }) => theme.colors.white};
  }

  .dropdown-item {
    text-decoration: none;
    display: inline-flex;
    padding: 8px 24px;
    color: #191919;
  }

  .dropdown-item img {
    vertical-align: top;
  }
  .dropdown-item:hover {
    background-color: #f6f6f6;
    color: #191919;
  }
`;

const TableRowOptionIcon = styled(SvgImage)`
  svg path {
    fill: #3b3c43;
  }
`;

const RowOptionIcon = styled(SvgImage)`
  padding-right: 8px;

  svg {
    path[fill] {
      fill: #3b3c43;
    }

    path[stroke] {
      stroke: #3b3c43;
    }

    circle {
      stroke: #3b3c43;
    }
  }
`;

const CustomToggle = React.forwardRef<HTMLButtonElement>(
  (props: ICustomToggleProps, buttonRef) => {
    const { children, onClick } = props;
    return (
      <RowOptionsToggle
        data-testid="hamburger-menu"
        type="button"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick(e);
          }
        }}
        ref={buttonRef}
      >
        {children}
      </RowOptionsToggle>
    );
  }
);

const RowOptions: React.FC<IRowOptionsProps> = (props: IRowOptionsProps) => {
  const { options, toggleComponent, alignRight = false } = props;

  return (
    <RowOptionsDropdown alignRight={alignRight}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom">
        {toggleComponent || (
          <TableRowOptionIcon
            inAssetsPath={getAssetPath('icons/table-row-options.svg')}
          />
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map(option => {
          return (
            <Dropdown.Item
              key={option.value}
              onClick={e => {
                e.stopPropagation();
                if (option.onClick) {
                  option.onClick();
                }
              }}
              data-testid={option.testId || 'dropdown_item'}
            >
              {option.icon && (
                <RowOptionIcon
                  className={clsx({
                    [option.iconClass]: !!option.iconClass
                  })}
                  inAssetsPath={option.icon}
                />
              )}
              <span
                className={clsx({
                  [option.textClass]: option.textClass
                })}
              >
                {option.value}
              </span>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </RowOptionsDropdown>
  );
};

export default RowOptions;
